import { mobile, tablet } from 'bowser';
import cookies from 'js-cookie';
import isUndefined from 'lodash/isUndefined';
import once from 'lodash/once';
import throttle from 'lodash/throttle';
import { CreateElement, VNode } from 'vue';
import { Component, Vue } from 'vue-property-decorator';
import { sbJs } from '../app.config';
import { FunctionalComponent } from '../decorators';
import { africaOptions } from '../globals';
import { uid } from '../helpers/utils';

const isTest = false;
const isTouchDevice = tablet || mobile;
const {enabled, campaignId, apiKey, firstName, lastName, timeout} = africaOptions.nps;
const npsUID = cookies.get('nps_uid') || uid();
const emailAddress = `${npsUID}@nps.aclass.dk`;

const hasInteraction = (): boolean => {
    const toggledForm = window.document.querySelectorAll('.c-enquire-form-fixed.is-toggled');
    const visiblePopup = window.document.querySelectorAll('.pswp--open');

    return toggledForm.length > 0 || visiblePopup.length > 0;
};

// Determine if the popup should be shown to the user.
const shouldShowPopup = (): boolean => {
    if (!isUndefined(cookies.get('nps_uid'))) {
        return false;
    }

    const sessionStart = sbJs.get.session.start || 0;

    // Time that user spent on the site
    const timeSpent = parseInt(Math.abs((Date.now() / 1000) - sessionStart).toString(10), 10);

    if (timeSpent < 120) {
        return false;
    }

    // Only run in 10% of cases.
    // return Math.random() <= 0.1;
    return true;
};

// Show popup
const showPopup = (): void => {
    if (!shouldShowPopup() || hasInteraction()) {
        return;
    }

    const src = isTest ?
        'https://npslib.azureedge.net/nps/npsbundle-test.js' :
        'https://npslib.azureedge.net/nps/npsbundle.js';

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;

    document.body.appendChild(script);

    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    cookies.set('nps_uid', npsUID, { path: '/', expires: expirationDate });
};

const showPopupOnce = once(showPopup);
let touchDeviceTicker;

const onTouchDevice = (): void => {
    if (shouldShowPopup()) {
        showPopupOnce();
        if (touchDeviceTicker) {
            clearInterval(touchDeviceTicker);
        }
    }
};

// Initialize popup code and listeners.
const initNpsPopup = () => {
    if (!shouldShowPopup()) {
        return;
    }

    if (!isTouchDevice) {
        document.addEventListener('mouseleave', onMouseOut);
        document.addEventListener('mouseover', throttle(clearMouseOut, 500));
    } else {
        touchDeviceTicker = setInterval(onTouchDevice, 10000);
    }
};

let timeoutId: number | undefined;

const onMouseOut = () => {
    if (!timeoutId) {
        timeoutId = window.setTimeout(showPopupOnce, timeout * 1000);
    }
};

const clearMouseOut = () => {
    if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
        timeoutId = undefined;
    }
};

const initNpsPopupOnce = once(initNpsPopup);

@Component
@FunctionalComponent
export default class NpsPopup extends Vue {
    public render(createElement: CreateElement): VNode {
        if (!enabled) {
            return createElement();
        }

        initNpsPopupOnce();

        return createElement('div', {
            attrs: {
                'ng-app': `nps`,
                'ng-controller': `InitController as vcontroller`,
                'ng-init': `vcontroller.open('${apiKey}',${campaignId},{emailAddress:'${emailAddress}',firstName:'${firstName}',lastName:'${lastName}'})`,
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/NpsPopup.ts